import {ThemeZIndexPath} from '../../types/ThemePaths';
import {ZINDEX_VALUES} from '../zIndexValues';

/**
 * Transforms zIndex theme path to actual numeric value
 */
export function toZIndexValue(value: unknown): number | 'auto' {
  return ZINDEX_VALUES[value as ThemeZIndexPath];
}
